import { v4 as uuidv4 } from "uuid";
import { InvitationData } from "./interface";
export const FONT_STYLE_LIST = [
  { name: "Pacifico", style: "pacifico-regular" },
  { name: "Amatic SC", style: "amatic-sc-regular" },
  { name: "Indie Flower", style: "indie-flower-regular" },
  { name: "Acme", style: "acme-regular" },
  { name: "Lakki Reddy", style: "lakki-reddy-regular" },
  { name: "Inter", style: "inter-regular" },
  { name: "Dancing Script", style: "dancing-script-regular" },
  { name: "Shadows Into Light", style: "shadows-into-light-regular" },
  { name: "Roboto", style: "roboto-regular" },
  { name: "Great Vibes", style: "great-vibes-regular" },
  { name: "Playfair Display", style: "playfair-display-regular" },
  { name: "Playfair Display Bold", style: "playfair-display-bold" },
  { name: "Montserrat", style: "montserrat-regular" },
  { name: "Montserrat Bold", style: "montserrat-bold" },
  { name: "Cinzel", style: "cinzel-regular" },
  { name: "Cinzel Semibold", style: "cinzel-semibold" },
  { name: "Alex Brush", style: "alex-brush-regular" },
  { name: "Satisfy", style: "satisfy-regular" },
  { name: "Allura", style: "allura-regular" },
  { name: "Rouge Script", style: "rouge-script-regular" },
  { name: "Kaushan Script", style: "kaushan-script-regular" },
  { name: "Lobster", style: "lobster-regular" },
  { name: "Courgette", style: "courgette-regular" },
  { name: "Cookie", style: "cookie-regular" },
  { name: "Sacramento", style: "sacramento-regular" },
  { name: "Allison", style: "allison-regular" },
  { name: "Aboreto", style: "aboreto-regular" },
  { name: "Aguafina Script", style: "aguafina-script-regular" },
  { name: "Annie Use Your Telescope", style: "annie-use-your-telescope-regular" },
  { name: "Anton", style: "anton-regular" },
  { name: "Arimo", style: "arimo-regular" },
  { name: "Biblo", style: "biblo-regular" },
  { name: "Caveat", style: "caveat-regular" },
  { name: "Coming Soon", style: "coming-soon-regular" },
  { name: "Creepster", style: "creepster-regular" },
  { name: "Delius", style: "delius-regular" },
  { name: "Fraunces", style: "fraunces-regular" },
  { name: "Fuzzy Bubbles", style: "fuzzy-bubbles-regular" },
  { name: "Gochi Hand", style: "gochi-hand-regular" },
  { name: "Homemade Apple", style: "homemade-apple-regular" },
  { name: "Imperial Script", style: "imperial-script-regular" },
  { name: "Josefin Sans", style: "josefin-sans-regular" },
  { name: "Libre Bodoni", style: "libre-bodoni-regular" },
  { name: "Luckiest Guy", style: "luckiest-guy-regular" },
  { name: "Macondo", style: "macondo-regular" },
  { name: "Marck Script", style: "marck-script-regular" },
  { name: "Meow Script", style: "meow-script-regular" },
  { name: "Miniver", style: "miniver-regular" },
  { name: "Patrick Hand", style: "patrick-hand-regular" },
  { name: "Pinyon Script", style: "pinyon-script-regular" },
  { name: "Praise", style: "praise-regular" },
  { name: "Rochester", style: "rochester-regular" },
  { name: "Sail", style: "sail-regular" },
  { name: "Sue Ellen Francisco", style: "sue-ellen-francisco-regular" },
];

export const FILTERS = [
  { label: "None", value: "none" },
  { label: "Grayscale", value: "grayscale(1)" },
  { label: "Sepia", value: "sepia(1)" },
  { label: "Invert", value: "invert(1)" },
  { label: "Blur", value: "blur(2px)" },
  { label: "High Contrast", value: "contrast(2)" },
  { label: "Brighten", value: "brightness(1.5)" },
];

export const TEXT_EFFECTS = [
  { label: "None", value: "none" },
  { label: "Shadow", value: "shadow" },
  { label: "Neon", value: "neon" },
  { label: "3D", value: "3d" },
  { label: "Blur", value: "blur" },
] as const;

export const NEON_GLOW_COLORS = [
  "#00ffff",
  "#ff007f",
  "#a855f7",
  "#00ff66",
  "#ffe600",
  "#ff5722",
  "#ffffff",
  "#3b82f6",
];

export const DEFAULT_INVITATION_DATA: InvitationData = {
  settings: {
    background_image: "",
  },
  texts: [
    {
      id: uuidv4(),
      type: "text",
      text: "you are invited",
      settings: {
        left: 10,
        top: 8,
        font_size: 3,
        is_selected: 1,
        editable: 0,
        width: 80,
        height: "auto",
        z_index: 20,
        font_family: "pacifico-regular",
        curved: false,
        curve_radius: 80, // e.g. 80px
        curve_direction: "up",
        opacity: 1,
        text_decoration: 'none'
      },
    },
  ],
  images: [],
  photos: [],
};
